export interface ILocalizationsRequest {
  names: string[];
  language: string;
}

export interface ILocalization {
  key: string;
  value: string;
}

export const localizationNames: string[] = [
  'calculator__choosing-network',
  'calculator__button-go',
  'calculator__time-minutes',
  'calculator__time-seconds',
  'calculator__speed-average',
  'calculator__popover-text',
  'calculator__choosing-token',
  'calculator__checkbox-text',
  'calculator__text-update',
  'calculator__speed-slow',
  'calculator__speed-optimal',
  'calculator__speed-fast',
  'calculator__description-part-1',
  'calculator__description-part-2',
];

export const defaultLocalizations: ILocalization[] = [
  {
    key: 'calculator__speed-average',
    value: 'AVERAGE',
  },
  {
    key: 'calculator__speed-slow',
    value: 'SLOW',
  },
  {
    key: 'calculator__speed-optimal',
    value: 'OPTIMAL',
  },
  {
    key: 'calculator__speed-fast',
    value: 'FAST',
  },
  {
    key: 'calculator__choosing-network',
    value: 'Choose your network',
  },
  {
    key: 'calculator__popover-text',
    value:
      'A native coin is a digital currency that is an integral part of its blockchain and is inextricably linked to it. For example, in the Bitcoin blockchain, the native coin is BTC, and in the Ethereum network, ETH.',
  },
  {
    key: 'calculator__choosing-token',
    value: 'Choose the token',
  },
  {
    key: 'calculator__checkbox-text',
    value: 'Native token',
  },
  {
    key: 'calculator__button-go',
    value: 'Go',
  },
  {
    key: 'calculator__time-minutes',
    value: 'min',
  },
  {
    key: 'calculator__time-seconds',
    value: 'sec',
  },
  {
    key: 'calculator__text-update',
    value: 'Update in',
  },
  {
    key: 'calculator__description-part-1',
    value: 'Specifics of commission calculation in',
  },
  {
    key: 'calculator__description-part-2',
    value: 'network',
  },
];
